







































































































































































import Vue from "vue";
export default Vue.extend({
  name: "PrivacyPolicy",
  metaInfo: {
    title: "Privacy policy"
  },
});

